import MUITextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import React from "react";
import { FieldTitle, useInput, useQuery } from "react-admin";

// Info: not used
// export const ArticleAutocompleteInput = (props) => {
// 	const { input: { name, onChange }, meta: { error, touched }, isRequired } = useInput(props);
// 	const articles = useGetList("pricelist-articles-autocomplete", {}, {}, {company_id: props.company_id});

// 	const filterOptions = React.useMemo(() => {
// 		return createFilterOptions({
// 			// matchFrom: 'any',
// 			matchFrom: 'start',
// 			// stringify: option => articles.data[option] ? `${articles.data[option].name} ${option}` : option.toString(),
// 			stringify: option => option.toString()
// 		});
// 	}, []);

// 	const getOptionLabel = React.useCallback((option) => {
// 		if (!articles.data[option]) return option;
// 		return `${articles.data[option].name} | ${option}`;
// 	}, [articles.data])

// 	return (
// 		<Autocomplete
// 			className="MuiFormControl-marginDense"
// 			fullWidth
// 			options={articles.ids}
// 			getOptionLabel={getOptionLabel}
// 			filterOptions={filterOptions}
// 			onChange={(e, value) => {
// 				onChange({ target: { name: name, value: value } });
// 				const selectedItem = articles.data[value];
// 				if (selectedItem) {
// 					props.onItemChange && props.onItemChange(selectedItem);
// 				}
// 			}}
// 			renderInput={(params) => (
// 				<MUITextField
// 					{...params}
// 					autoFocus={props.autoFocus}
// 					error={!!(touched && error)}
// 					helperText={touched ? error : ' '}
// 					required={isRequired}
// 					label={<FieldTitle resource={params.resource} source={props.source} label={props.label} isRequired={isRequired} />}
// 					variant="filled"
// 					size="small"
// 				/>
// 			)}
// 		/>
// 	);
// }

export const ArticleAutocompleteInputAdvanced = ({
	className,
	fullWidth,
	size,
	style,
	variant = "filled",
	filter: additionalFilter = {},
	margin,
	disabled,
	excludeCodes = [],
	exceptExcludingCurrent = true,
	...props
}) => {
	const {
		input: { name, onChange, value: inputValue },
		meta: { error, touched },
		isRequired,
	} = useInput(props);

	const filter = {
		terminal_id: props.terminal_id,
		company_id: props.company_id,
		...additionalFilter,
	};
	if (disabled && inputValue) {
		filter.code = inputValue;
	}

	const { data, loading } = useQuery(
		{
			type: "getList",
			resource: "pricelist-articles-autocomplete",
			payload: {
				pagination: {},
				sort: {},
				filter: filter,
			},
		},
		{
			enabled: !(disabled && !inputValue),
		}
	);

	const filteredData = React.useMemo(() => {
		if (!data) return [];
		if (!excludeCodes || excludeCodes.length === 0) return data;
		if (exceptExcludingCurrent && inputValue) {
			return data.filter(
				(option) => !(excludeCodes.includes(option.code) && option.code !== inputValue)
			);
		} else return data.filter((option) => !excludeCodes.includes(option.code));
	}, [data, excludeCodes, exceptExcludingCurrent, inputValue]);

	const selectedOption = React.useMemo(() => {
		if (!filteredData || !inputValue) return null;
		return filteredData.find((option) => option.code === inputValue);
	}, [filteredData, inputValue]);

	const getOptionLabel = React.useCallback((option) => {
		return `${option.name} | ${option.code}`;
	}, []);

	const filterOptions = React.useCallback((opts, val) => {
		const search = val.inputValue.trim();
		if (!search) return opts;

		const regAllDigit = /^\d+$/;

		if (regAllDigit.test(search)) {
			const optsByCode = [];
			const optsByName = [];
			for (const opt of opts) {
				if (opt.code.toString().substring(0, search.length) === search) {
					optsByCode.push(opt);
				} else if (opt.name.indexOf(search) !== -1) {
					optsByName.push(opt);
				}
			}
			return optsByCode.concat(optsByName);
		} else {
			const regSearch = new RegExp(search, "i");
			return opts.filter((el) => regSearch.test(el.name));
		}
	}, []);

	return (
		<Autocomplete
			value={selectedOption || null}
			className={className}
			fullWidth={fullWidth}
			style={style}
			loading={loading}
			disabled={disabled}
			options={filteredData || []}
			getOptionLabel={getOptionLabel}
			filterOptions={filterOptions}
			onChange={(e, value) => {
				onChange({ target: { name: name, value: value?.code } });
				if (value) {
					props.onItemChange(value, name);
				}
			}}
			renderInput={(params) => (
				<MUITextField
					{...params}
					autoFocus={props.autoFocus}
					error={!!(touched && error)}
					helperText={touched ? error : null}
					required={isRequired}
					label={
						<FieldTitle
							resource={params.resource}
							source={props.source}
							label={props.label}
							isRequired={isRequired}
						/>
					}
					variant={variant}
					size={size}
					margin={margin}
				/>
			)}
		/>
	);
};
